import { ReactElement } from 'react';

import { DocumentSendError } from '@dreryk/egabinet-ezla-frontend-api';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { StyledMedicalLeaveDocumentErrorsStatusContent } from './MedicalLeaveDocumentErrorsStatusContent.styled';

type MedicalLeaveDocumentErrorsStatusContentProps = {
   readonly errors: DocumentSendError[];
};

export const MedicalLeaveDocumentErrorsStatusContent = (
   props: MedicalLeaveDocumentErrorsStatusContentProps
): ReactElement => {
   if (props.errors.length === 1) {
      const [onlyError] = props.errors;
      return (
         <>
            {onlyError.errorCode} {onlyError.errorMessage}
         </>
      );
   }

   return (
      <StyledMedicalLeaveDocumentErrorsStatusContent>
         {props.errors.map((error) => (
            <li key={error.errorCode} {...appendTestableElementAttributes(error.errorCode ?? 'zlaDocumentSendError')}>
               {error.errorCode} {error.errorMessage}
            </li>
         ))}
      </StyledMedicalLeaveDocumentErrorsStatusContent>
   );
};
